import React, { useRef } from 'react'
import { FieldRenderProps } from 'react-final-form'
import styles from '../../styles'
import IntlTelInput, { CountryData } from 'react-intl-tel-input'
import 'react-intl-tel-input/dist/main.css'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'
import { useIntl } from 'react-intl'
import { fontFamilyMonserrat } from '../../theme'

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	containerStyle: {
		width: '100%',
		height: '100%',
		'& :focus-visible': {
			outline: 'none'
		}
	},
	inputStyle: {
		...styles(theme).text8,
		border: 'none',
		width: '100%',
		height: '100%'
	},
	errorStyle: {
		color: '#B92D00',
		fontSize: '10px',
		position: 'absolute',
		marginTop: 5
	},
	phoneFieldContainer: {
		height: 61,
		'& fieldset': {
			borderColor: theme.palette.blue['50'],
			borderWidth: 1,
			borderRadius: 4,
			borderStyle: 'solid',
			padding: '0 16px',
			height: '100%',
			width: '100%',
			'& legend': {
				color: theme.palette.blue['50'],
				fontFamily: fontFamilyMonserrat,
				fontSize: 12
			}
		}
	}
}))

interface AcceptingProps {
	label?: string,
	placeholder?: string
}

type FormPhoneFieldProps =
	FieldRenderProps<string>
	& AcceptingProps

const FormPhoneField: React.FC<FormPhoneFieldProps> = (
	{
		input,
		meta: { touched, error },
		label,
		placeholder = ''
	}
) => {
	const { classes, cx } = useStyles()
	const inputRef = useRef(null)
	const intl = useIntl()

	const textFieldClass = cx(
		'intl-tel-input',
		classes.containerStyle
	)

	const inputClass = cx(
		'phone-input',
		classes.inputStyle
	)

	/**
	 * Fonction pour replacer le curseur à la fin de l'input (le formatage du numéro déplace le curseur au milieu du champ)
	 */
	const setPositionCurseur = (positionCurseur: number) => {
		const elem = document.getElementsByClassName('phone-input')[0] as HTMLInputElement

		if (elem) {
			elem.focus()
			setTimeout(() => {
				elem.setSelectionRange(positionCurseur, positionCurseur)
			}, 0)
		}
	}

	const onChange = (isValid: boolean, value: string, selectedCountryData: CountryData, fullNumber: string) => {
		setPositionCurseur(fullNumber.length)
		input.onChange(fullNumber)
	}

	return (
		<Grid container item className={classes.phoneFieldContainer}>
			<fieldset>
				<legend>{intl.formatMessage({ id: label })}</legend>
				<IntlTelInput
					inputClassName={inputClass}
					ref={inputRef}
					preferredCountries={['fr']}
					placeholder={placeholder}
					onPhoneNumberChange={onChange}
					containerClassName={textFieldClass}
					value={input.value}
				/>
			</fieldset>
			{touched && error && <Grid item><span className={classes.errorStyle}>{error}</span></Grid>}
		</Grid>
	)
}

export default FormPhoneField